import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'social_studio.review.referred': {
    schema: z.object({
      postId: z.uuid(),
      commentId: z.uuid(),
      commentVersion: z.string().min(1).max(160),
      title: z.string().min(1).max(120),
      network: z.enum(['instagram', 'facebook', 'linkedin']),
      scenario: z.enum(['novafit', 'greentech', 'cafe_maison']),
      author: z.string().max(120),
      body: z.string().max(6000),
      receivedAt: z.iso.datetime(),
      reason: z.string().min(10).max(2000),
    }),
    journal: { label: fr.referralEvent, importance: 'normal' },
    realtime: true,
  },
  'social_studio.changed': {
    schema: z.object({ id: z.uuid() }),
    journal: { label: fr.changedEvent, importance: 'normal' },
    realtime: true,
  },
  'social_studio.post.due': {
    schema: z.object({ id: z.uuid(), queueKey: z.uuid() }),
    journal: { label: fr.dueEvent, importance: 'normal' },
    realtime: true,
  },
});
